<template>
  <div class="modal customer_popup open_modal" data-modal="customer_popup">
    <div class="modal_overlay" @click="overlyCloseModal()" ></div>
    <div class="modal_inner">
      <slot name="inner" />
      <div class="modal_wrapper ">
        <div class="modal_header" :class="headerClasses">
          <slot name="header" />
          <div class="float_right">
            <span class="close_modal"  @click="closeModal()"></span>
          </div>
        </div>
        <div ref="modal_content" class="modal_content" :class="modalSize">
          <slot name="content" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalComponent",
  props: {
    options: {
      type: Object,
      default() {
        return {
          btnClose: true,
          overlyClose: true,
        };
      },
    },
    modalSize: {
      type: String,
      required: false,
      default: 'modal_1080p',
    },
    headerClasses: {
      type: String,
      required: false,
      default: '',
    },
    contentClasses: {
      type: String,
      required: false,
      default: '',
    },
  },
  emits: ["closeModal"],
  data() {
    return {
      btnClose: true,
      overlyClose: false,
    };
  },
  watch: {
    options(options) {
      this.btnClose = options.btnClose ? options.btnClose : true;
      this.overlyClose = options.overlyClose ? options.overlyClose : false;
    },
  },
  created() {
    window.$('body').addClass('model_open')
  },
  mounted() {
    let options = this.options;
    this.btnClose = options.btnClose ? options.btnClose : true;
    this.overlyClose = options.overlyClose ? options.overlyClose : false;
  },
  methods: {
    overlyCloseModal() {
      // if (this.overlyClose) {
      //   this.$emit("closeModal");
      // }
    },
    closeModal() {
      window.$('body').removeClass('model_open')
      if (this.btnClose) {
        this.$emit("closeModal");
      }
    },
  },
};
</script>
